import React, {useState} from 'react';
import {Card, CardBody, CardHeader} from "reactstrap";
import {Link} from "react-router-dom";
import appUserRoutes from "../../../appUserRoutes";
import {getByModuleId, MODULE_TIMES} from "../Modules";
import BodyForTimesSelect from "./BodyForTimesSelect";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import apiUser from "../../../apiUser";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import {isNil} from "lodash";
import ModuleCardList from "../ModuleCardList";

const TimesCard = props => {
  const { getApiPrimaryParams, showType, ident } = useTecRmi()
  const [loading, setLoading] = useState(false)
  const [bodyForTimes, setBodyForTimes] = useState()
  const [times, setTimes] = useState([])

  useAfterUpdateEffect(() => {
    fetchData()
  }, [bodyForTimes])

  const fetchData = () => {
    if(isNil(bodyForTimes)){
      return
    }

    setLoading(true)

    apiUser.tecRmi.times.workList({
      ...getApiPrimaryParams(),
      showPaint: true,
      paintBodyQualColId: bodyForTimes,
      bodyQualColId: bodyForTimes,
    })
      .then(res => setTimes(res.data))
      .finally(() => setLoading(false))
  }

  return (
    <Card className="h-100">
      <CardHeader className="p-1">
        <Link className="d-flex flex-row flex-nowrap align-items-center py-1" to={appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_TIMES, 'uriName'), bodyForTimes)}>
          <img src={getByModuleId(MODULE_TIMES, 'icon')} style={{ height: 24 }} />
          <span className="ml-1">{getByModuleId(MODULE_TIMES, 'name')}</span>
        </Link>
      </CardHeader>
      <CardBody>
        <BodyForTimesSelect
          onChange={setBodyForTimes}
        />

        {loading && <LoadingSpinner />}
        <ModuleCardList
          items={times.map((time, key) => <Link to={appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_TIMES, 'uriName'), [bodyForTimes, time.MainGroupId].join('/'))} key={key.toString()}>{time.MainGroupName}</Link>)}
        />
      </CardBody>
    </Card>
  );
};

TimesCard.propTypes = {

};

export default TimesCard;